import React from 'react';
import './Onboarding_Print.scss';
import { useTranslation } from 'react-i18next';
import setPropertyVh from '../../utils/setPropertyVh';
import StepRequirement from 'components/StepRequirement/StepRequirement';
import CourseTheatreReicpe from "../../flows/CourseTheatreRecipe";
import usePDFdetails from 'utils/hooks/getPDFdetails';
import Xbutton from 'components/Xbutton';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';

const Onboarding_Print = ({
    onExit,
    onBack,
    exitButtonType = 'x',
    isFirstStep = true,
    lessonPathname,
    onContinue,
}) => {
    const {t} = useTranslation();
    const { pdfUrl, thumbSrc } = usePDFdetails(lessonPathname);
    setPropertyVh();

    const handleOnPrint = () => {
        window.open(pdfUrl, '_blank')
    }

    return (
        <>
            <div className={"Onboarding-container"}>
                <div className={"Onboarding-header"}>
                    <div className={"Onboarding-header__side"}>
                        {exitButtonType === 'exit' && <ButtonCircle classes="ButtonCircle-exit ButtonCircle-50px" onClick={onExit} />}
                    </div>
                    <div className={"Onboarding-header__center"}>{t("onboarding.whatNeedForLesson")}</div>
                    <div className={"Onboarding-header__side Onboarding-header__side--end"}>
                        {exitButtonType === 'x' && <Xbutton sizeM onClose={onExit} />}
                        {exitButtonType === 'exit' && !isFirstStep && <ButtonCircle classes="ButtonCircle-back ButtonCircle-50px" onClick={onBack} />}
                    </div>
                </div>
                <div className={"Onboarding-content hideScrollbar Onboarding_Print__content"}>
                        <div className={"Onboarding-title"}>{t("onboarding.Onboarding_Print.title")}</div>
                        <div className={"Onboarding-description"}>{t("onboarding.Onboarding_Print.subtitle")}</div>
                        <div className="content-ab content-column ">
                            {/* <button onClick={handleOnPrint} className={"buttonCatbears buttonCatbears_CTA req-container_miniButton"}>
                                <img src="/assets/icons/icon-print.svg" />
                                {t("general.printActivityPages")}
                            </button>  */}
                            <img className="activityPageThumb" src={thumbSrc} alt="activity page" onClick={handleOnPrint} style={{cursor: 'pointer'}} />
                        </div>
                        <div className='Room'></div>
                </div>
                <div className={"Onboarding-footer"}>
                    {/* <button onClick={onContinue} className={"button Onboarding-button Onboarding-button-primary catbearsCTA-secondary"}>
                    {t("onboarding.Onboarding_Print.cta2")}
                    </button> */}
                    <button onClick={handleOnPrint} className={"button Onboarding-button buttonCatbears buttonCatbears_White"}>
                    {t("general.printActivityPages")}
                    <img src="/assets/icons/icon-print.svg" />
                    </button>
                    <button onClick={onContinue} className={"button Onboarding-button buttonCatbears buttonCatbears_CTA arcadeBtn"}>
                        {t("onboarding.Onboarding_Print.cta")}
                    </button>          
                </div>
            </div>
        </>
        )

}

export default Onboarding_Print